import { useMutation } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { toast } from 'sonner';
import { authClient } from '~/shared/lib/auth';

export const useSignOutMutation = (href: string) => {
    const t = useTranslations();
    return useMutation({
        mutationKey: ['signOut'],
        mutationFn: async () => {
            const { error } = await authClient.signOut();
            if (error) {
                throw new Error(t('auth.errors.signOutFailed'));
            }
        },
        retry: false,
        onSuccess: () => {
            const url = href || '/';
            setTimeout(() => {
                window.location.replace(url);
            }, 0);
        },
        onError: error => {
            toast.error(error.message);
        },
    });
};
